import { Text } from '@cad-arc';
import React from 'react';
import styles from './pinned-divider-row.module.css';

export function PinnedDividerRow({
    hiddenCount,
    isExpanded,
    onToggle,
}: {
    hiddenCount: number;
    isExpanded: boolean;
    onToggle: () => void;
}): React.JSX.Element {
    return (
        <div
            className={styles['divider']}
            onClick={onToggle}
            data-testid="PINNED_DIVIDER_ROW"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onToggle();
                }
            }}
        >
            <Text className={styles['toggle-text']}>
                {isExpanded ? 'Show less \u25B2' : `Expand all pinned (${hiddenCount} more) \u25BC`}
            </Text>
        </div>
    );
}
